import { deepFind } from "./jsonUtils";

export const sort = (values, itemSort) => {
    const { order, field } = itemSort;
    const array = [...values]

    array.sort((a, b) => {
      const valueA = deepFind(a, field);
      const valueB = deepFind(b, field);
      
      if (valueA < valueB) {
        return order === 1 ? -1 : 1; // ASC or DESC
      }
      
      if (valueA > valueB) {
        return order === 1 ? 1 : -1; // ASC or DESC
      }
      
      return 0;
    });

    return array
}